<template>
    <div class="mod-register">
        <mini-header :headerTitle="'修改账户信息'"></mini-header>
        <div class="register-main">
            <div class="mod-title">
                <h1>修改账户信息</h1>
                <span class="under-line"></span>
            </div>
            <el-form :model="oldForm" disabled label-width="110px" class="demo-ruleForm">
                <el-divider content-position="left">原账户信息</el-divider>
                <div class="form_panel">
                    <el-form-item label="原用户名" prop="name">
                        <el-input v-model="oldForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="原手机号码" prop="phone">
                        <el-input v-model="oldForm.phone"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                <el-divider content-position="left">新账户信息</el-divider>
                <div class="form_panel">
                    <el-form-item label="新用户名" prop="name">
                        <el-row :gutter="10" style="margin: 0;">
                            <el-col :span="14">
                                <el-input v-model="ruleForm.name" maxlength="11"></el-input>
                            </el-col>
                            <el-col :span="10" style="color: #606266;">注：用户名不一致，原账号失效。</el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label="新手机号码" prop="newPhone">
                        <el-row :gutter="10" style="margin: 0;">
                            <el-col :span="12">
                                <el-input v-model="ruleForm.newPhone" maxlength="11"></el-input>
                            </el-col>
                            <el-col :span="12" style="color: #606266;">注：手机号修改成功后以新号重新登录。</el-col>
                        </el-row>
                    </el-form-item>
                    <el-row :gutter="18">
                        <el-col :span="15">
                            <el-form-item label="验证码" prop="captchaNewPhone">
                                <el-input v-model="ruleForm.captchaNewPhone" maxlength="6"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="9">
                            <div class="getcaptcha" @click="getCaptchaHandle">
                                <span v-show="showCaptcha">获取验证码</span>
                                <span v-show="!showCaptcha">{{ count }}s后重新发送</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-form-item label="QQ号" prop="qq">
                        <el-input v-model="ruleForm.qq" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="微信号" prop="wx">
                        <el-input v-model="ruleForm.wx" maxlength="30"></el-input>
                    </el-form-item>
                    <el-form-item label="头像上传" prop="avatar">
                        <el-upload :headers="headerSet" :action="upFilesUrl" accept=".jpg,.png" class="uploader" :show-file-list="false" :on-success="handleAvatarSuccess">
                            <el-image v-if="ruleForm.avatar" :src="getUrl(ruleForm.avatar)">
                                <div slot="placeholder" class="image-slot">
                                    加载中<span class="dot">...</span>
                                </div>
                            </el-image>
                            <i v-if="!ruleForm.avatar" class="el-icon-plus"></i>
                            <div class="el-upload__tip" slot="tip">仅支持JPG/PNG格式。</div>
                        </el-upload>
                    </el-form-item>
                </div>
                <div class="btn-control">
                    <el-button round @click="$router.push({ name: 'register', query: { userInfo: 1 } })">取消</el-button>
                    <el-button type="primary" round @click="submitForm">提交申请</el-button>
                </div>
            </el-form>
        </div>
        <main-footer></main-footer>
    </div>
</template>

<script>
import { isMobile } from "@/utils/validate";
import MiniHeader from "./../common/mini-header.vue";
import MainFooter from "./../main-footer.vue";
import { previewUrl } from "@/utils";
export default {
    components: {
        MiniHeader,
        MainFooter
    },
    data() {
        var validateMobile = (rule, value, callback) => {
            if (!isMobile(value)) {
                callback(new Error("手机号格式错误"));
            } else {
                callback();
            }
        };
        return {
            upFilesUrl: window.SITE_CONFIG.baseUrl + '/checkmall-file/api/file/upload',
            oldForm: {
                name: '',
                phone: ""
            },
            ruleForm: {
                id: '',
                newPhone: "",
                name: "",
                captchaNewPhone: "",
                qq: "",
                wx: "",
                avatar: ''
            },
            rules: {
                name: [
                    { required: true, message: "请输入新用户名", trigger: "blur" }
                ],
                newPhone: [
                    { required: true, message: "请输入新手机号码", trigger: "blur" },
                    { validator: validateMobile, trigger: "blur" },
                ],
                captchaNewPhone: [
                    { required: true, message: "验证码不能为空", trigger: "blur" },
                    { min: 6, max: 6, message: "验证码错误", trigger: "blur" }
                ]
            },
            showCaptcha: true,
            count: "",
            timer: null
        };
    },
    computed:{
        headerSet() {
            return { 'X-Admin-Token': this.$cookie.get('X-Admin-Token') }
        }
    },
    mounted() {
        // 获取用户信息
        this.$http.get(this.$api.shiroApi.userInfo).then(({ data }) => {
            this.oldForm.name = data.data.name;
            this.oldForm.phone = data.data.phone;
            this.ruleForm.id = data.data.id;
        });
    },
    methods: {
        getUrl(url) {
            return previewUrl(url);
        },
        handleAvatarSuccess(res) {
            if (res.code == 200) {
                this.ruleForm.avatar = res.data.storage.filePreviewUrl;
            } else {
                this.$message({
                message: res.msg,
                type: "error"
                });
            }
        },
        // 表单提交
        submitForm() {
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    this.$http.post(this.$api.shiroApi.uUpdateUser, this.ruleForm).then(({ data }) => {
                        if (data.code === 200) {
                            this.$message({
                                message: "修改成功",
                                type: "success"
                            });
                        }
                    });
                }
            });
        },
        // 获取验证码基于手机号
        getCaptchaHandle() {
            if (!this.showCaptcha) return
            this.$refs["ruleForm"].validateField("newPhone", (valid) => {
                if (!valid) {
                    let params = {
                        phone: this.ruleForm.newPhone,
                    };
                    this.$http.post(this.$api.shiroApi.sendCaptchaByPhone, params).then(({ data }) => {
                        if (data.code === 200) {
                            this.countdown(60);
                        }
                    });
                }
            });
        },
        // 倒计时
        countdown(second) {
            const TIME_COUNT = second;
            if (!this.timer) {
                this.count = TIME_COUNT;
                this.showCaptcha = false;
                this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                    } else {
                        this.showCaptcha = true;
                        clearInterval(this.timer);
                        this.timer = null;
                    }
                }, 1000);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.getcaptcha {
    height: 42px;
    line-height: 42px;
    color: #1460AE;
    border: 1px solid #dcdfe6;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
}

.uploader {
    width: 320px;
    height: 156px;
    border-radius: 4px;
    border: 1px solid #DEDEDE;


    ::v-deep .el-upload {
        width: 100%;
        height: 100%;
        line-height: 156px;
        text-align: center;
    }

    .el-image {
        height: 154px;
    }

    i {
        font-size: 26px;
        width: 100%;
        color: #999;
    }

    .el-upload__tip {
        line-height: 14px;
    }
}
</style>
